import { Alert, Button, Input } from "@material-tailwind/react";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";
import AdminTable, { ClickableData } from "components/AdminTable";
import AspectRatioDiv from "components/utils/AspectRatioDiv";
import { AlertContext } from "contexts/AlertProvider";
import useAxiosPrivate from "hooks/useAxiosPrivate";
import { useContext, useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import { Navigate, useNavigate } from "react-router-dom";
import { CSSTransition } from "react-transition-group";
import { axiosErrorHandler } from "utils/common";
import EventsCreateMenu from "./EventsCreateMenu";
import VendorCreateMenu from "./BusinessCreateMenu";

const LIMIT = 10

const Events = ()=>{
    const [selected, setSelected] = useState<{[x:number] : boolean}>({})
    const [active, setActive] = useState<null | number>(null);
    const [createMenuOpened, setCreateMenuOpened] = useState(false);
    const navigate = useNavigate()
    const [page, setPage] = useState(1);
    const [pageCount, setPageCount] = useState(0);
    
    const axiosPrivate = useAxiosPrivate()
    const queryClient = useQueryClient();
    const {setAlert} = useContext(AlertContext)
    
    useEffect(()=>{
        setSelected({});
    },[page, createMenuOpened])

    useEffect(() => {
      const keyHandler = ({ key }:KeyboardEvent) => {
        if (!createMenuOpened || key !== 'Escape') return;
        setCreateMenuOpened(false);
      };
      document.addEventListener('keydown', keyHandler);
      return () => document.removeEventListener('keydown', keyHandler);
    });

    useEffect(()=>{
        if(!createMenuOpened)
            setActive(null);
    }, [createMenuOpened])

    const {data, isError} = useQuery(['events', page, {limit: LIMIT, published : false}], async ()=>{
        const {data : _data} = await axiosPrivate.get(`/events?page=${page}&limit=${LIMIT}`)
        const data = _data[0].map((datum:any)=>{
            return {
                key : datum.id,
                submittedBy : datum.submittedBy.id,
                data : [datum.title, datum.eventDate, datum.category.title],
            }
        })
        setPageCount(Math.ceil(_data[1] / LIMIT));
        return data;
    }, {
        onError : axiosErrorHandler(navigate, setAlert)
    })

    const handlePageClick = (event: {
        selected: number;
    }) => {
      setPage(event.selected+1)
    };

    const handleDestroy = async()=>{
        const _selected = Object.keys(selected).map((selectId)=>{
            if(selected[parseInt(selectId)])
                return selectId
        }) || []
        return axiosPrivate.post('events/bulk-delete', {ids :_selected})
    }
    const {mutate : bulkDestroy} = useMutation(handleDestroy, {
        onSuccess(){
            queryClient.invalidateQueries(['events'])
            setAlert('success', 'Items deleted')
            setSelected({})
        },
        onError : axiosErrorHandler(navigate, setAlert)
    })

    return (
        <>
            {( createMenuOpened &&
                <EventsCreateMenu setMenuOpened={setCreateMenuOpened} selected={active}/>
            )}
            <div className=" flex flex-row-reverse" onClick={()=>setCreateMenuOpened(true)}>
                <Button color="blue" className="font-semibold text-sm">
                    Add New Blog
                </Button>
            </div>
            <AdminTable handleDestroy={bulkDestroy} onClick={(target)=>{setActive(target); setCreateMenuOpened(true)}} selected={selected} setSelected={setSelected} 
            headers={["Title", "Event Date", "category"]} data={data}/>
            <ReactPaginate
              className="react-paginate mt-8"
              breakLabel="..."
              onPageChange={handlePageClick}
              pageRangeDisplayed={5}
              pageCount={pageCount}
              nextLabel={<i className="fas fa-chevron-right"/>}
              previousLabel={<i className="fas fa-chevron-left"/>}
              //@ts-ignore
              renderOnZeroPageCount={null}
            />
        </>
    )
}

export default Events;